import { createContext, useReducer } from 'react';
import { useLanguageContext } from "../hooks/useLanguageContext";
import translations from "../translations";

export const CompanyContext = createContext();

export const companyReducer = (state, action) => {
  switch (action.type) {
    case 'SET_COMPANY': 
      return {
        company: action.payload
      };
    case 'CLEAR_COMPANY':
      return {
        company: null
      };
    default:
      return state;
  }
};

export const CompanyContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(companyReducer, {
    company: null
  });
  const { language } = useLanguageContext(); // ✅ Taal ophalen uit de context

  return (
    <CompanyContext.Provider value={{
      ...state, 
      dispatch, 
      t: translations[language]
    }}>
      { children }
    </CompanyContext.Provider>
  );
};
